<template>
  <div class="ViewData">
    <div>{{ $t("DataSerch.browsingData") }}</div>
    <ul class="">
      <li
        v-for="(item, index) in TopDataSat"
        :key="index"
        @click="toDatadetails(item.data_id)"
      >
        <div class="num">{{ index + 1 }}</div>
        <div class="name">{{ item.product_name }}</div>
      </li>
    </ul>
  </div>
</template>

<script>
import { topDataSat } from "@/axios/datashare.js";
export default {
  data() {
    return {
      TopDataSat: [],
    };
  },
  mounted() {
    this.getTopDataSat().then((res) => {
      this.TopDataSat = res.data.data.slice(0, 10);
    });
  },
  methods: {
    async getTopDataSat() {
      return await topDataSat();
    },
      toDatadetails(dataId) {
      // console.log(item)
      this.$router.push(`/datadetails?dataId=${dataId}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.ViewData {
  margin-top: 10px;
  margin-left: 20px;
  width: 315px;
  background: #fff;
  border-radius: 6px;
  padding: 20px;
  border: 1px solid #eeeeee;
  ul {
    margin-top: 10px;
    border-top: 1px solid #ccc;
    padding: 10px 0;
    li {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
            width: 270px;
      .num {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 2px;
        min-width: 20px;
        height: 20px;
        color: #fff;
        background: rgba(216, 184, 121, 1);
        margin-right: 10px;
      }
        margin-bottom: 20px;
      .name{
      
      font-size: 14px;
      white-space: nowrap;
      width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      }
    }
  }
}
</style>